import { PopoverWidget } from '@tableau/widgets';
import React from 'react';

import { cssClass } from '~src/style';

import { CommonStyles } from '../../styles/CommonStyles';

export interface CellWithPopoverProps {
  cellContent: React.ReactChild;
  popoverContent: React.ReactChild;
  title: string;
  showTitleBar?: boolean;
}

const rootClass = 'cellWithPopover';

const wrapper = cssClass(rootClass, 'wrapper', {
  ...CommonStyles.Layout.FlexBlockLeftAndCenter,
  cursor: 'pointer',
});

function renderCell(content: React.ReactChild) {
  return (
    <div className={wrapper}>
      {content}
    </div>
  );
}

export function CellWithPopover(props: CellWithPopoverProps) {
  return (
    <PopoverWidget
      popoverContent={props.popoverContent}
      triggerElement={renderCell(props.cellContent)}
      title={props.title}
      showTitleBar={props.showTitleBar}
    />
  );
}
